module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-pager/ztsi-pager.component.css
// module id = ./src/app/components/shared/ztsi-pager/ztsi-pager.component.css
// module chunks = main